const iconConfigs = {
  skip: {
    identifier: 'circle-check',
    toolTipText: 'Unverified',
    className: 'verification-status-skip gray-txt-23',
  },
  valid: {
    identifier: 'circle-check',
    toolTipText: 'Valid',
    className: 'verification-status-valid green-txt-14',
  },
  risky: {
    identifier: 'danger',
    toolTipText: 'Risky',
    className: 'verification-status-risky orange-txt-6',
  },
  bad: {
    identifier: 'warning',
    toolTipText: 'Bad',
    className: 'verification-status-bad red-txt-6',
  },
  unknown: {
    identifier: 'danger',
    toolTipText: 'Risky',
    className: 'verification-status-unknown red-txt-6',
  },
  inProgress: {
    identifier: 'rotate-clockwise',
    toolTipText: 'In Progress',
    className: 'verification-status-inProgress gray-txt-23',
  },
};

export const getEmailVerificationIcon = (verificationStatus: string) =>
  iconConfigs[verificationStatus];
